import { createFileRoute } from '@tanstack/react-router'

import { ActivitySpecificQuestionsDocumentationPage } from '../../../../components/pages/backoffice/platform/platform-documentation/activity-specific-questions-documentation-page.tsx'

export const Route = createFileRoute('/bo/documentation/activity-specific-questions')({
  component: () => <ActivitySpecificQuestionsDocumentationPage />,
})
